export default "__VITE_ASSET__030d712f__"